import useMediaQuery from "@core-ui/hooks/useMediaQuery";
import { cssMedia } from "@core-ui/utils/cssUtils";
import { getBlockToolbarRegistry } from "@ext/markdown/elements/article/edit/helpers/BlockToolbarRegistry";
import { resolveToolbarContext } from "@ext/markdown/elements/article/edit/helpers/resolveToolbarContext";
import type { Editor } from "@tiptap/core";
import { CellSelection } from "prosemirror-tables";
import { useCallback } from "react";

export const useShouldShowInlineToolbar = () => {
	const isMobile = useMediaQuery(cssMedia.JSnarrow);

	return useCallback(
		({ editor }: { editor: Editor }) => {
			if (!editor || editor.isDestroyed || !editor.isEditable || isMobile) return false;
			const context = resolveToolbarContext(editor.state);
			if (context.kind === "file") return true;
			if (context.kind !== "text") return !!getBlockToolbarRegistry(editor).at(context.pos);
			if (editor.state.selection.$from.parent.type.name === "code_block") return false;

			const { from, to, empty } = editor.state.selection;
			if (empty) return false;

			const text = !!editor.state.doc.textBetween(from, to);
			const isCellSelection = editor.state.selection instanceof CellSelection;

			if ((!text && !isCellSelection) || editor.state.doc.firstChild === editor.state.selection.$from.parent) {
				return false;
			}

			return true;
		},
		[isMobile],
	);
};
